import { render, staticRenderFns } from "./ChurnRate.vue?vue&type=template&id=b1e20b4c&scoped=true&"
import script from "./ChurnRate.vue?vue&type=script&lang=js&"
export * from "./ChurnRate.vue?vue&type=script&lang=js&"
import style0 from "./ChurnRate.vue?vue&type=style&index=0&id=b1e20b4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e20b4c",
  null
  
)

export default component.exports